export default "__VITE_ASSET__CXPUjRoe__"